import { useEffect, useState } from "react";
import Apiservice from "../Apiservice";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const QuizEdit = () => {

    const location = useLocation();
    const quizId = location.state?.quizId || 0;
    const examId = location.state?.examId || 0;
    const fromReport = location.state?.fromReport || false;
    const reportFilters = location.state?.reportFilters || {};

    const navigate = useNavigate();
    const [user_id, setUserId] = useState(0);
    const [questions, setQuestions] = useState([]);
    const [questionLocation, setQuestionLocation] = useState(0);
    const [currentQuestion, setCurrentQuestion] = useState([]);
    const [currentOptions, setCurrentOptions] = useState([]);
    const [summary, setSummary] = useState([]);
    const [questionStatus, setQuestionStatus] = useState([]);
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [finalAlertModal, setFinalAlertModal] = useState(false);

    const [parsedState, setParsedState] = useState({});
    const [examDate, setExamDate] = useState('');
    const [examEndDate, setExamEndDate] = useState('');
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [timeTaken, setTimetaken] = useState('');

    const [startTimeDate, setStartTimeDate] = useState(null);
    const [endTimeDate, setEndTimeDate] = useState(null);
    const [formattedStartTime, setFormattedStartTime] = useState('');
    const [formattedEndTime, setFormattedEndTime] = useState('');


    const [loading, setLoading] = useState(true);

    const handleStartTimeChange = (e) => {
        const time = e.target.value;
        setStartTime(time);

        if (examDate) {
            const start = new Date(`${examDate}T${time}`);
            setStartTimeDate(start);
        }
    };

    const handleEndTimeChange = (e) => {
        const time = e.target.value;
        setEndTime(time);

        if (examDate) {
            const end = new Date(`${examDate}T${time}`);
            setEndTimeDate(end);
        }
    };

    useEffect(() => {
        if (examDate && startTime) {
            const start = new Date(`${examDate}T${startTime}`);
            setStartTimeDate(start);
        }

        if (examDate && endTime) {
            const end = new Date(`${examDate}T${endTime}`);
            setEndTimeDate(end);
        }
    }, [examDate, startTime, endTime]);





    useEffect(() => {
        let data = {
            "id": quizId,
            "status": 0
        }
        const fetchData = async () => {
            let result = await Apiservice.QuizEdit(data);
            if (result.success === true) {
                let retrievedData = result.data[0];

                setUserId(retrievedData.user_id);
                // Check if summary is a string and parse it
                const parsedSummary = typeof retrievedData.summary === "string"
                    ? JSON.parse(retrievedData.summary)
                    : retrievedData.summary;

                setSummary(parsedSummary); // ✅ This is now an array
                //  setSummary(retrievedData.summary);
                setQuestions(retrievedData.questions);
                const state = retrievedData.state;
                const parsedState = JSON.parse(state);
                setParsedState(parsedState);

            }
        };
        fetchData();
    }, [quizId]);

    useEffect(() => {
        if (questions.length > 0) {
            const statusArray = questions.map((q) => {
                const isAnswered = summary.some((s) => s.question_id === q.id);
                return { isAnswer: isAnswered ? 1 : 0 };
            });
            setQuestionStatus(statusArray);
        }
    }, [questions, summary]);

    useEffect(() => {
        if (parsedState.startTime) {
            const date = new Date(parsedState.startTime);

            if (!isNaN(date)) {
                const timeOnly = date.toTimeString().slice(0, 5); // HH:MM
                setStartTime(timeOnly);
                setStartTimeDate(date); // Store raw Date object if needed

                const readableStart = date.toLocaleString('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: true
                });

                setFormattedStartTime(readableStart); // NEW STATE
                const examDate = extractDateForInput(date);
                setExamDate(examDate);

            }
        }

        if (parsedState.endTime) {
            const date = new Date(parsedState.endTime);

            if (!isNaN(date)) {
                const timeOnly = date.toTimeString().slice(0, 5); // HH:MM
                setEndTime(timeOnly);
                setEndTimeDate(date); // Store raw Date object if needed

                const readableEnd = date.toLocaleString('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: true
                });

                setFormattedEndTime(readableEnd); // NEW STATE
                const endDate = extractDateForInput(date)
                setExamEndDate(endDate);
            }
        }

        setTimetaken(parsedState.timeTaken)

    }, [parsedState]);
    const extractDateForInput = (dateTimeStr) => {
        const dateObj = new Date(dateTimeStr);

        if (isNaN(dateObj)) {
            console.error("Invalid date string");
            return "";
        }

        const year = dateObj.getFullYear();
        const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
        const day = dateObj.getDate().toString().padStart(2, "0");

        return `${year}-${month}-${day}`; // "YYYY-MM-DD"
    };



    useEffect(() => {
        if (startTimeDate && endTimeDate) {
            const diffMs = endTimeDate - startTimeDate;

            if (diffMs >= 0) {
                const totalSeconds = Math.floor(diffMs / 1000);
                const minutes = Math.floor(totalSeconds / 60);
                const seconds = totalSeconds % 60;

                const result = `${minutes} min ${seconds} sec`;
                setTimetaken(result);
            } else {
                setTimetaken("Invalid time range");
            }
        } else {
            setTimetaken(""); // or "Waiting for both times"
        }
    }, [startTimeDate, endTimeDate]);


    console.log("timeTaken", timeTaken)


    const handleSubmit = async () => {
        const formatDate = (dateObj) => {
            return dateObj?.toLocaleString('en-US', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true
            }) || '';
        };
        const data = {
            id: quizId,
            exam_id: examId,
            questionAttempt: summary.length,
            summary: summary,
            startTime: formatDate(startTimeDate),
            endTime: formatDate(endTimeDate),
            timeTaken: timeTaken,
            status: 0,
        };
        // const token = localStorage.getItem("access_token");

        // // Define custom headers
        // const headers = {
        //     access_token: token, // Pass the token in the Authorization header
        // };
        console.log("data", data)
        const result = await Apiservice.QuizUpdate(data);
        console.log("result", result);
        if (result.success) {

            if (fromReport) {

                navigate("/lmsreport", {
                    state: {
                        refresh: true,
                        filters: reportFilters
                    }
                });

            } else {

                navigate(`/quizreview/${quizId}`);

            }

        } else {
            console.error("Failed to submit summary:", result.message);
        }
    };

    const handleNext = () => {
        if (questionLocation < questions.length - 1) {
            // Move to the next question
            setQuestionLocation((prev) => prev + 1);
        }
    };

    const handlePrevious = () => {
        if (questionLocation > 0) {
            setQuestionLocation((prev) => prev - 1);
        }
    };

    useEffect(() => {
        if (questions.length > 0 && questions[questionLocation]) {
            const q = questions[questionLocation];
            setCurrentQuestion(q);
            const parsedCurrentOption = typeof q === "string"
                ? JSON.parse(q)
                : q.options;
            setCurrentOptions(parsedCurrentOption);
            setLoading(false);
            console.log("parsed Current Options", parsedCurrentOption)
        }
    }, [questionLocation, questions]);


    const handleOptionChange = (event, questionIndex) => {
        const optionSelected = event.target.value;

        // Update the question status
        setQuestionStatus((prevStatus) => {
            const updatedStatus = [...prevStatus];
            updatedStatus[questionIndex] = { isAnswer: 1 };
            return updatedStatus;
        });

        // Parse options if they are string
        const currentQuestion = questions[questionLocation];
        const options =
            typeof currentQuestion.options === "string"
                ? JSON.parse(currentQuestion.options)
                : currentQuestion.options;

        const optionKey = `option${optionSelected}`;
        const selectedOptionObject = options.find((opt) =>
            Object.keys(opt).includes(optionKey)
        );

        const isCorrect = selectedOptionObject?.isCorrect ? 1 : 0;

        // Update the summary
        setSummary((prev) => {
            const updatedSummary = prev.filter(
                (item) => item.question_id !== currentQuestion.id
            );

            const response = {
                question_id: currentQuestion.id,
                selected_option: optionSelected,
                isCorrect: isCorrect,
            };

            return [...updatedSummary, response];
        });
    };

    const handleClearChoice = () => {
        setSummary((prevSummary) =>
            prevSummary.filter(item => item.question_id !== questions[questionLocation].id)
        );

        setQuestionStatus((prevStatus) => {
            const updatedStatus = [...prevStatus];
            updatedStatus[questionLocation] = { isAnswer: 0 }; // Reset the question status
            return updatedStatus;
        });
    };


    return (
        <>
            <div className="container-fluid" style={{ backgroundColor: 'ButtonFace', userSelect: 'none' }}>
                <div className="row mb-1">
                    {
                        loading ? (
                            <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
                                <div className="text-center">
                                    {/* Spinner with proper rotation */}
                                    <div
                                        className="spinner-border text-primary"
                                        role="status"
                                        style={{
                                            width: "2rem",
                                            height: "2rem",
                                            borderWidth: "3px",
                                        }}
                                    >
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    {/* Minimalist Text */}
                                    <p className="mt-2 text-secondary small fw-semibold">Please wait...</p>
                                </div>
                            </div>
                        )
                            :
                            (
                                <>
                                    <div className="col-9">
                                        <div className="row mb-1 p-1 m-1" style={{ backgroundColor: 'snow' }}>
                                            <div className="col text-center"><h5 className="h5">QUIZ EDIT</h5></div>
                                        </div>
                                        {questions.length > 0 ? (
                                            <>
                                                <div className="row mb-2 border border-2-black border-rounded radius-2 p-2 m-2" style={{ backgroundColor: 'snow' }}>
                                                    <div className="col">
                                                        <div className="d-flex flex-wrap gap-2">
                                                            {questions.map((q, index) => (
                                                                <div
                                                                    key={index}
                                                                    className="position-relative border border-black"
                                                                    style={{
                                                                        width: '50px',
                                                                        height: '70px',
                                                                        borderRadius: '10px',
                                                                        backgroundColor: 'ButtonFace',
                                                                        overflow: 'hidden',
                                                                        cursor: 'pointer',
                                                                    }}
                                                                    onClick={() => setQuestionLocation(index)}
                                                                >
                                                                    {/* Top Half */}
                                                                    <div
                                                                        className="w-100 h-50"
                                                                        style={{
                                                                            backgroundColor: index === questionLocation ? 'lightgreen' : 'aliceblue',
                                                                            borderBottom: '1px solid black',
                                                                        }}
                                                                    ></div>

                                                                    {/* Bottom Half */}
                                                                    <div
                                                                        className="w-100 h-50"
                                                                        style={{ backgroundColor: 'ButtonFace' }}
                                                                    ></div>

                                                                    {/* Corner Cutting Indicator */}
                                                                    {questionStatus[index]?.isAnswer === 0 && (
                                                                        <div
                                                                            className="position-absolute"
                                                                            style={{
                                                                                width: '0',
                                                                                height: '0',
                                                                                borderLeft: '20px solid transparent',
                                                                                borderTop: '20px solid red',
                                                                                top: '0',
                                                                                right: '0',
                                                                            }}
                                                                        ></div>
                                                                    )}

                                                                    {/* Question Number */}
                                                                    <div
                                                                        className="position-absolute w-100 text-center"
                                                                        style={{ bottom: '5px', fontSize: '12px' }}
                                                                    >
                                                                        {index + 1}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row mb-2 border border-2-black p-2 m-2" style={{ backgroundColor: 'snow' }}>
                                                    <div className="col">
                                                        <div className="row mb-2 border">
                                                            <div className="row">
                                                                <div className="col-12 col-md">Question : {questionLocation + 1}</div>
                                                                {/* <div className="col-12 col-sm-3 col-md"> {questionLocation + 1} </div> */}
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md col-12">
                                                                    <div className="row">
                                                                        <div className="col"><h6>Status - {questionStatus[questionLocation]?.isAnswer === 0 ? "Not yet Answered" : "Answered"}</h6></div>
                                                                    </div>
                                                                </div>
                                                                <div className="col">
                                                                    <div className="row">
                                                                        <div className="col">Marked out of 1</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row mb-2">
                                                            <div className="col">
                                                                <div className="row">
                                                                    <div className="col"><p>{currentQuestion.question}</p></div>
                                                                </div>
                                                                {console.log("currentOptionlength", currentOptions.length - 1)}
                                                                {/* {
                                                                    currentOptions.length > 0 && (
                                                                        JSON.parse(currentOptions).slice(0, currentOptions.length - 1).map((option, index) => (
                                                                            <div className="row" key={index}>
                                                                                <div className="col">
                                                                                    <div className="row mb-1">
                                                                                        <div className="col-md-1 col-2">
                                                                                            <input
                                                                                                type="radio"
                                                                                                className="btn-check"
                                                                                                name="options"
                                                                                                id={`option${index + 1}`}
                                                                                                value={index + 1}
                                                                                                checked={summary.some(
                                                                                                    (item) =>
                                                                                                        item.question_id === questions[questionLocation].id &&
                                                                                                        item.selected_option === `${index + 1}`
                                                                                                )}
                                                                                                onClick={(e) => handleOptionChange(e, questionLocation)} // Pass the correct question index
                                                                                            />
                                                                                            {console.log("questions", questions)}
                                                                                            <label
                                                                                                className="btn btn-outline-danger"
                                                                                                htmlFor={`option${index + 1}`}
                                                                                            >
                                                                                                {index === 0 ? "a" : index === 1 ? "b" : index === 2 ? "c" : "d"}
                                                                                            </label>
                                                                                        </div>
                                                                                        <div className="col-md-11 col">
                                                                                            {option[`option${index + 1}`]}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ))
                                                                    )
                                                                } */}
                                                                {currentOptions && (
                                                                    (() => {
                                                                        const parsedOptions = JSON.parse(currentOptions);

                                                                        // Filter only objects that have an "option1", "option2", etc.
                                                                        const validOptions = parsedOptions.filter((opt) =>
                                                                            Object.keys(opt)[0]?.startsWith("option")
                                                                        );

                                                                        return validOptions.map((option, index) => (
                                                                            <div className="row" key={index}>
                                                                                <div className="col">
                                                                                    <div className="row mb-1">
                                                                                        <div className="col-md-1 col-2">
                                                                                            <input
                                                                                                type="radio"
                                                                                                className="btn-check"
                                                                                                name="options"
                                                                                                id={`option${index + 1}`}
                                                                                                value={index + 1}
                                                                                                checked={summary.some(
                                                                                                    (item) =>
                                                                                                        item.question_id === questions[questionLocation].id &&
                                                                                                        item.selected_option === `${index + 1}`
                                                                                                )}
                                                                                                onClick={(e) => handleOptionChange(e, questionLocation)}
                                                                                            />
                                                                                            <label
                                                                                                className="btn btn-outline-danger"
                                                                                                htmlFor={`option${index + 1}`}
                                                                                            >
                                                                                                {["a", "b", "c", "d"][index] || ""}
                                                                                            </label>
                                                                                        </div>
                                                                                        <div className="col-md-11 col">
                                                                                            {option[`option${index + 1}`]}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ));
                                                                    })()
                                                                )}

                                                            </div>
                                                        </div>
                                                        <div className="row floart-start mb-2">
                                                            <div className="col">
                                                                <button className="btn btn-sm btn-outline-danger" onClick={handleClearChoice}>Clear My Choise</button>
                                                            </div>
                                                        </div>
                                                        <div className="row mb-2">
                                                            <div className="col">
                                                                {questionLocation > 0 && (
                                                                    <button className="btn btn-sm btn-outline-danger float-start" onClick={handlePrevious}>
                                                                        Previous Question
                                                                    </button>
                                                                )}
                                                            </div>

                                                            <div className="col text-end">
                                                                {questionLocation < questions.length - 1 && (
                                                                    <button className="btn btn-sm btn-outline-primary float-end" onClick={handleNext}>
                                                                        Next Question
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col text-center">
                                                                {
                                                                    questionLocation === questions.length - 1 && (
                                                                        <button className="btn btn-primary btn-sm" onClick={() => setShowAlertModal(true)}>
                                                                            Update
                                                                        </button>
                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <div className="row mb-2 border border-2-black border-rounded radius-2 p-2 m-2" style={{ backgroundColor: 'snow' }}>
                                                <div className="col text-center">
                                                    <h5 className="h5">No questions are available</h5>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="col-12 col-md-3 mt-2">
                                        <div className="card shadow-sm p-3 rounded-4 border-0 bg-light">
                                            <h6 className="mb-3 fw-bold text-primary">Schedule Details</h6>

                                            <div className="mb-3">
                                                <label htmlFor="date" className="form-label fw-semibold">Stat Date</label>
                                                <input
                                                    type="date"
                                                    id="date"
                                                    className="form-control form-control-sm border-primary"
                                                    value={examDate}
                                                    onChange={(e) => setExamDate(e.target.value)}
                                                />
                                            </div>

                                            <div className="mb-3">
                                                <label htmlFor="startTime" className="form-label fw-semibold">Start Time</label>
                                                <input
                                                    type="time"
                                                    id="startTime"
                                                    className="form-control form-control-sm border-success"
                                                    value={startTime}
                                                    onChange={handleStartTimeChange}
                                                />
                                            </div>

                                            {/* <div className="mb-3">
                                                <label htmlFor="date" className="form-label fw-semibold">End Date</label>
                                                <input
                                                    type="date"
                                                    id="date"
                                                    className="form-control form-control-sm border-primary"
                                                    value={examEndDate}
                                                    onChange={(e) => setExamEndDate(e.target.value)}
                                                />
                                            </div> */}

                                            <div className="mb-0">
                                                <label htmlFor="endTime" className="form-label fw-semibold">End Time</label>
                                                <input
                                                    type="time"
                                                    id="endTime"
                                                    className="form-control form-control-sm border-danger"
                                                    value={endTime}
                                                    onChange={handleEndTimeChange}
                                                />
                                            </div>
                                            <div className="mb-0">
                                                <label className="form-label fw-semibold">Time Taken</label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm border-danger"
                                                    value={timeTaken}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                    </div>


                                    {showAlertModal && !finalAlertModal && (
                                        <>
                                            <div className="modal-backdrop fade show"></div> {/* Background fade effect */}
                                            <div className="modal fade show d-block" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" style={{ opacity: finalAlertModal ? 0.5 : 1 }}>
                                                <div className="modal-dialog modal-dialog-centered"> {/* Centered modal with larger width */}
                                                    <div className="modal-content shadow-lg rounded-3">
                                                        <div className="modal-header bg-dark text-white">
                                                            <h5 className="modal-title" id="staticBackdropLabel">Test Summary</h5>
                                                            <button type="button" className="btn-close text-white" data-bs-dismiss="modal" aria-label="Close" onClick={() => setShowAlertModal(false)}></button>
                                                        </div>

                                                        {/* Scrollable Modal Body */}
                                                        <div className="modal-body p-3" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                                            {summary.length > 0 ? (
                                                                questions.length > 0 ? (
                                                                    <div className="table-responsive">
                                                                        <table className="table table-bordered table-striped table-hover">
                                                                            <thead className="table-dark text-center">
                                                                                <tr>
                                                                                    <th>Sl. No</th>
                                                                                    <th>Status</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody className="text-center">
                                                                                {questions.map((question, index) => (
                                                                                    <tr key={index}>
                                                                                        <td className="fw-bold text-primary cursor-pointer" onClick={() => { setShowAlertModal(false); setQuestionLocation(index); }} onMouseEnter={(e) => e.target.style.cursor = 'pointer'}>{index + 1}</td>
                                                                                        <td className={questionStatus[index]?.isAnswer === 0 ? "text-danger" : "text-success"}>
                                                                                            {questionStatus[index]?.isAnswer === 0 ? "Not yet Answered" : "Answered"}
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                ) : (
                                                                    <div className="alert alert-warning text-center">
                                                                        <h6>No Questions Available</h6>
                                                                    </div>
                                                                )
                                                            ) : (
                                                                <div className="alert alert-danger text-center">
                                                                    <h6>Attend At Least One Question</h6>
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* Footer with Buttons */}
                                                        <div className="modal-footer bg-light">
                                                            <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal" onClick={() => setShowAlertModal(false)}>Back to Quiz</button>
                                                            <button type="button" className={`btn btn-primary btn-sm ${summary.length === 0 ? "disabled" : ""}`} onClick={() => setFinalAlertModal(true)}>Update</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    {finalAlertModal && (
                                        <>
                                            <div className="modal-backdrop fade show"></div> {/* Background fade effect */}
                                            <div className="modal fade show d-block" id="finalBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="finalBackdropLabel" aria-hidden="true" style={{ zIndex: 1051 }}>
                                                <div className="modal-dialog modal-dialog-centered modal-sm"> {/* Centered modal with larger width */}
                                                    <div className="modal-content shadow-lg rounded-3">
                                                        <div className="modal-header bg-dark text-white">
                                                            <button type="button" className="btn-close text-white" data-bs-dismiss="modal" aria-label="Close" onClick={() => setFinalAlertModal(false)}></button>
                                                        </div>

                                                        {/* Scrollable Modal Body */}
                                                        <div className="modal-body p-3" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                                            <h6>Update the Results Anyway?</h6>
                                                        </div>

                                                        {/* Footer with Buttons */}
                                                        <div className="modal-footer bg-light">
                                                            <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal" onClick={() => setFinalAlertModal(false)}>Cancel</button>
                                                            <button type="button" className={`btn btn-primary btn-sm ${summary.length === 0 ? "disabled" : ""}`} onClick={() => handleSubmit()}>Update</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </>
                            )
                    }



                </div >
            </div >
        </>
    );
};

export default QuizEdit;
